import React, { useMemo } from "react"
import {
  faChevronRight,
  faIndianRupeeSign,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"

import { setCurrentPartyDaysRange,  setIsFromDashboardPayable } from "../../../state/outstandingPayableSlice.jsx"
import { useFetchWithBody } from "../../../api/reactQueryCustomHooks.jsx"
import { calculateTotal, pivotData } from "../../../Utility/utility.js"
import { ErrorCard, LoadingCard, MainContainer, NextUITable } from "../../../components/index.js"  
import { apiRoute,  linksUrl, outTypeEnum } from "../../../constants/enum.js"
import { COLUMN_ALIGN_TYPE, FOOTER_TYPE, ROW_ACTION_BTN_TYPE } from "../../../components/NextUITable.jsx"

const OutPPartyAgeSummary = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { user } = useSelector((state) => state.auth)
  const { compCode } = useSelector((state) => state.company)
  const { currentParty } = useSelector((state) => state.outstandingPayable)

  const {
    isLoading,
    isError,
    data = [],
  } = useFetchWithBody({
    url: apiRoute.outstanding.partyAgingSummary,
    queryKey: "OutstandingPayablePartyAgeSummary"+ currentParty.id,
    manipulateData: true,
    manipulateDataFn: (newData) => {
      return pivotData({ data: [newData[0]] })
    },
    inputData: {
      compcode: compCode.join(","),
      party_id: currentParty.id,
      out_type: outTypeEnum.G,
     // db_user:GetLoginCredentialDb (user,yearId)
    },
  })

  const handleClickPrev = () => {
    navigate(linksUrl.outstanding.payable.partySummary)
  }

  const totalpartyAgeSummary = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "daysRemaning",
      }),
    [data]
  )

  let downloadDataFooter = {
    daysRange: "",
    daysRemaning: "Total: " + totalpartyAgeSummary,
  }

  const exportColumns = [
    {
      uid: "daysRange",
      name: "Days Range",
    },
    {
      uid: "daysRemaning",
      name: "Aging",
    },
  ]

  const handleFooterNext = () => {
    dispatch(setCurrentPartyDaysRange({ daysRange: "All" }))
    navigate(linksUrl.outstanding.payable.partyDetail)
  }

  const INITIAL_VISIBLE_COLUMNS = ["daysRange", "actions"]

  const columns = [
    {
      name: "Aging",
      uid: "daysRange",
      secondCol: {
        name: "daysRemaning",
        icon: <FontAwesomeIcon icon={faIndianRupeeSign} size="sm" />,
      },
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total:",
        value: totalpartyAgeSummary,
      },
    },
    {
      name: "Days Remaning",
      uid: "daysRemaning",
    },
    {
      name: "ACTIONS",
      uid: "actions",
      //align:COLUMN_ALIGN_TYPE.center,
      footer: {
        type: FOOTER_TYPE.link,
        label: "next",
        icon: <FontAwesomeIcon icon={faChevronRight} />,
        onClick: handleFooterNext,
      },
    },
  ]
  

  const rowActionBtn = [
    {
      icon: <FontAwesomeIcon icon={faChevronRight} />,
      onClick: (row) => {
        dispatch(setCurrentPartyDaysRange(row))
        dispatch(setIsFromDashboardPayable(false))
        navigate(linksUrl.outstanding.payable.partyDetail)
      },
      type:  ROW_ACTION_BTN_TYPE.link,
      label: "next",
    },
  ]

  if (isLoading) {
    return <LoadingCard />
  }

  if (isError) {
    return <ErrorCard />
  }

  return (
    <MainContainer
      pageName="Party Aging Summary"
      info={[["Party", currentParty.name]]}
      breadcrumbs={["Payable", "Party Aging Summary"]}
      prevPage={{
        show: true,
        onClick: handleClickPrev,
      }}
    >
      <NextUITable
        INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
        data={data}
        columns={columns}
        exportColumns={exportColumns}
        rowActionBtn={rowActionBtn}
        downloadDataFooter={downloadDataFooter}
        showAdvanceFilter={false}
        downloadFileName="Payable_Outstanding_Summary"
        id="party_id"
      />
    </MainContainer>
  )
}

export default OutPPartyAgeSummary
